<template>
    <div class="consult-cost-dialog">
        <el-dialog
            title="参考成本"
            :visible.sync="showConsultCostDialog"
            width="80%"
            :before-close="closeDialog">
            <el-button class="consult-cost-buton" type="text" icon="el-icon-upload" @click="exportConsultCost">导出</el-button>
            <div class="consult-table">
                <!-- 多表组件 -->
                <multi-level-table :tableheight="300" :tableData="tableData" :columnData="columnData" v-loading="loadConsultCostDialog"></multi-level-table>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import multiLevelTable from '../../../components/multi-level-table/multiLevelTable';
import { dictWithUrl } from '@/components/lots/api';
import { checkConsultCost, exportConsultCost } from '../../../api/tenderDetails.js';

export default {
    name: 'consult-cost-dialog',
    data () {
        return {
            tableData: [],
            dictData: {},
            columnData: [
                {
                    prop: '',
                    label: '',
                    width: '1px'
                },
                {
                    label: '客户名称',
                    prop: 'customerName',
                    width: '150px'
                }, {
                    label: '线路编码',
                    prop: 'lineCode',
                    width: '150px'
                }, {
                    label: '线路名称',
                    prop: 'lineName'
                }, {
                    label: '起点省份',
                    prop: 'startProvinceName'
                }, {
                    label: '起点城市',
                    prop: 'startCityName'
                }, {
                    label: '起点县或区',
                    prop: 'startDistrictName'
                }, {
                    label: '起点街道',
                    prop: 'startStreetName'
                }, {
                    label: '目的省份',
                    prop: 'targetProvinceName',
                    width: '50px'
                }, {
                    label: '目的城市',
                    prop: 'targetCityName'
                }, {
                    label: '目的县或区',
                    prop: 'targetDistrictName'
                }, {
                    label: '目的街道',
                    prop: 'targetStreetName'
                }, {
                    label: '业务类型',
                    prop: 'businessType'
                }, {
                    label: '运输类型',
                    prop: 'transportType'
                }, {
                    label: '计费方式',
                    prop: 'chargeUnit'
                }, {
                    label: '上游收入(元)',
                    prop: 'upstreamRevenueMap',
                    children: [
                        {
                            prop: '',
                            label: '',
                            width: '1px'
                        }
                    ]
                }, {
                    label: '历史投标成本(元)',
                    prop: 'tenderCostMap',
                    children: [
                        {
                            prop: '',
                            label: '',
                            width: '1px'
                        }
                    ]
                }, {
                    label: '历史运作成本(元)',
                    prop: 'historicalCostMap',
                    children: [
                        {
                            prop: '',
                            label: '',
                            width: '1px'
                        }
                    ]
                }, {
                    label: '市场成本(元)',
                    prop: 'databaseCost',
                    width: '100px'
                }, {
                    label: '',
                    prop: '',
                    width: '1px'
                }, {
                    label: '',
                    prop: '',
                    width: '1px'
                }
            ],
            loadConsultCostDialog: false
        };
    },
    props: {
        showConsultCostDialog: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        params: {
            type: Object,
            default: function () {
                return {};
            }
        }
    },
    components: { multiLevelTable },
    methods: {
        closeDialog() {
            this.$emit('update:showConsultCostDialog', false);
        },
        dealColumn(item, structure, prop) {
            if (structure[prop] && Object.keys(structure[prop]).length > 0) {
                item.children = [];
                for (const key in structure[prop]) {
                    if (structure[prop].hasOwnProperty(key) && prop === 'historicalCostMap') {
                        item.children.push({
                            label: key,
                            prop: prop + key.split('.')[0],
                            width: '150px'
                        });
                    } else if (structure[prop].hasOwnProperty(key)) {
                        item.children.push({
                            label: key + this.getOptionLabelWithValue(this.dictData.SRM_CT_BILLING_UNIT, structure.unit),
                            prop: prop + key.split('.')[0],
                            width: '150px'
                        });
                    }
                }
            }
        },
        dealGear(prop, item, index) {
            if (item[prop]) {
                for (const key in item[prop]) {
                    if (item[prop].hasOwnProperty(key)) {
                        item[prop + key.split('.')[0]] = item[prop][key];
                    }
                }
                delete item[prop];
            }
        },
        loadData() {
            if (this.params) {
                const params = this.params;
                params.pageNo = 1;
                params.pageSize = 999;
                this.loadConsultCostDialog = true;
                checkConsultCost(params).then(res => {
                    if (res) {
                        this.loadConsultCostDialog = false;
                        const structure = JSON.parse(JSON.stringify(res.data.list[0]));
                        res.data.list.forEach(item => {
                            if (item.historicalCostMap) {
                                structure.historicalCostMap = item.historicalCostMap;
                            }
                            if (item.tenderCostMap) {
                                structure.tenderCostMap = item.tenderCostMap;
                            }
                            if (item.upstreamRevenueMap) {
                                structure.upstreamRevenueMap = item.upstreamRevenueMap;
                            }
                            if (item.unit) {
                                structure.unit = item.unit;
                            }
                        });
                        const columnData = JSON.parse(JSON.stringify(this.columnData));
                        columnData.forEach(item => {
                            if (item.prop === 'upstreamRevenueMap') {
                                this.dealColumn(item, structure, 'upstreamRevenueMap');
                            } else if (item.prop === 'tenderCostMap') {
                                this.dealColumn(item, structure, 'tenderCostMap');
                            } else if (item.prop === 'historicalCostMap') {
                                this.dealColumn(item, structure, 'historicalCostMap');
                            }
                        });
                        this.columnData = JSON.parse(JSON.stringify(columnData));
                        res.data.list.forEach((item, index) => {
                            this.dealGear('upstreamRevenueMap', item, index);
                            this.dealGear('tenderCostMap', item, index);
                            this.dealGear('historicalCostMap', item, index);
                            if (item.businessType) {
                                item.businessType = this.getOptionLabelWithValue(this.dictData.BID_BUSINESS_TYPE, item.businessType);
                            }
                            if (item.chargeUnit) {
                                item.chargeUnit = this.getOptionLabelWithValue(this.dictData.SRM_CT_BILLING_METHOD, item.chargeUnit);
                            }
                        });
                        this.tableData = res.data.list;
                    }
                    this.loadConsultCostDialog = false;
                });
            }
        },
        exportConsultCost() {
            const params = this.params;
            params.pageNo = 1;
            params.pageSize = 999;
            exportConsultCost(params).then(res => {
                if (res) {
                    const blob = new Blob([res], {
                        type: 'application/x-excel;charset=UTF-8'
                    });
                    const objectUrl = URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = objectUrl;
                    a.download = '参考成本信息.xlsx';
                    a.click();
                    this.$message.success('导出成功');
                } else {
                    this.$message.warning('导出失败');
                }
            });
        },
        getOptionLabelWithValue(ops, key) {
            for (const i in ops) {
                if (i === key) {
                    return ops[key];
                }
            }
        }
    },
    watch: {
        params() {
            this.loadData();
        }
    },
    mounted() {
        dictWithUrl('BID_BUSINESS_TYPE,SRM_CT_BILLING_METHOD,SRM_CT_BILLING_UNIT').then(res => {
            if (res) {
                this.dictData = res.data;
            }
            this.loadData();
        });
    }
};
</script>
<style lang="less">
.consult-cost-dialog {
    .consult-cost-buton {
        float: right;
        font-size: 14px;
        margin-bottom: 16px;
    }
    .consult-table {
        width: 100%;
        height: 400px;
    }
    .table-pagination {
        padding-top: 10px;
    }
    .el-table__body {
        overflow: hidden !important;
    }
}
</style>